<template>
  <section class="war-room-job-application-banner">
    <div class="war-room-job-application-banner__picture">
      <success class="war-room-job-application-banner__success" />
    </div>
    <div class="war-room-job-application-banner__content">
      <button class="war-room-job-application-banner__close" type="button" @click="$emit('close')">
        <close-icon class="war-room-job-application-banner__close-icon" />
      </button>
      <h2 class="war-room-job-application-banner__header">Your Job Application was sent!</h2>
      <p class="war-room-job-application-banner__description">We'll notify you when we find a match!</p>
      <p class="war-room-job-application-banner__description">While you wait:</p>
      <ul class="war-room-job-application-banner__bullet-list">
        <li v-for="bullet in bullets" :key="bullet" class="war-room-job-application-banner__bullet-item">
          {{ bullet }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts" setup>
import CloseIcon from '@/assets/svg/close.vue.svg';
import Success from '@/components/partials/war-room/WarRoomJobApplicationBanner/assets/success.vue.svg';

const bullets = [
  'Network with over 200k sales professionals',
  'Earn commission for contributing',
  'Exchange commission for real rewards',
];
</script>

<style lang="scss">
.war-room-job-application-banner {
  box-shadow: var(--theme-elevation-01);
  position: relative;
  border-bottom: 1px solid var(--theme-color-border);
  background-color: var(--theme-cyan_lc_2);
  color: var(--theme-color-text);

  @include mq('sm') {
    border-bottom: none;
    border-radius: 16px;
    display: flex;
    align-items: flex-end;
  }

  &__picture {
    display: none;

    @include mq('sm') {
      display: block;
    }
  }

  &__success {
    display: block;
    margin-left: 16px;
  }

  &__content {
    padding: 24px;

    @include mq('sm') {
      padding: 24px 16px;
    }
  }

  &__close {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  }

  &__close-icon {
    height: 32px;
    width: 32px;
    color: var(--gray-50);
  }

  &__header {
    @include header5;

    margin-bottom: 12px;
    padding-right: 24px;
  }

  &__description {
    @include body;

    color: var(--theme-color-sub-text);

    &:last-of-type {
      margin-bottom: 12px;
    }
  }

  &__bullet-list {
    padding-left: 18px;
    list-style-type: circle;
  }

  &__bullet-item {
    @include body;

    position: relative;

    &::marker {
      color: var(--theme-color-sub-text);
      font-size: 18px;
      line-height: 18px;
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    @include mq('sm') {
      @include subhead;
    }
  }
}
</style>
